var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      color: "#fff"
    },
    focusable: "false",
    "data-prefix": "fa-light",
    "data-icon": "house-user",
    className: "svg-inline--fa fa-house-user fa-w-18",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 351.1c-44.18 0-79.1 35.82-79.1 79.1c0 8.835 7.164 15.1 15.1 15.1c8.836 0 16-7.175 16-16.01c0-26.51 21.49-47.1 47.1-47.1h63.1c26.51 0 47.1 21.49 47.1 47.1c0 8.835 7.164 16.01 16 16.01c8.836 0 15.1-7.164 15.1-15.1c0-44.18-35.82-79.1-79.1-79.1H256zM224 255.1c0 35.34 28.65 63.1 63.1 63.1S351.1 291.3 351.1 255.1s-28.65-63.1-63.1-63.1S224 220.7 224 255.1zM319.1 255.1c0 17.64-14.36 32.01-31.1 32.01S256 273.6 256 255.1S270.4 223.1 288 223.1S319.1 238.3 319.1 255.1zM575.1 255.1c0-4.432-1.826-8.846-5.408-12.01l-58.62-51.87c.002-.0898 0 .0898 0 0l.0239-144.1c0-8.843-7.156-15.1-15.1-15.1l-95.1 .0089c-8.844 0-15.1 7.156-15.1 15.1l-.0016 31.35l-85.41-75.36c-3.031-2.656-6.812-3.996-10.59-3.996c-3.781 0-7.563 1.34-10.59 3.996L5.41 243.1c-3.582 3.159-5.409 7.572-5.409 12c0 8.828 7.136 15.99 16.01 15.99c3.757 0 7.533-1.313 10.59-3.993l37.41-33v196.1c0 44.12 35.87 79.1 79.1 79.1h287.1c44.12 0 79.1-35.87 79.1-79.1V234.1l37.41 33c3.062 2.687 6.812 3.1 10.59 3.1C568.8 271.1 575.1 264.8 575.1 255.1zM415.1 64h63.1v100.1l-63.1-56.47V64zM479.1 207.1v223.1c0 26.47-21.53 47.1-47.1 47.1H144c-26.47 0-47.1-21.53-47.1-47.1V207.1c0-.375-.1875-.6875-.2129-1.055L288 37.35l192.2 169.6C480.2 207.3 479.1 207.6 479.1 207.1z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c1165ca34bcbb1c18f0177b57ed08a12.svg";
export { ForwardRef as ReactComponent };